import React, { useEffect, useState } from "react";
import { FaKey, FaSpinner } from "react-icons/fa6";
import { LiaTimesCircle } from "react-icons/lia";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { deleteCentre, showSwal, stripSpace } from "../../AppManager";
import { nanoid } from "nanoid";

export default function CentreDelete() {
  const { centre } = useParams();
  const { centres, setCentres } = useOutletContext();
  const navigate = useNavigate();
  const [crkey, setCrkey] = useState("");
  const [keyword, setKeyword] = useState("loading...");
  const [status, setStatus] = useState({ status: "", type: "", message: "" });
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState(true);

  useEffect(() => {
    if (first) {
      try {
        if (centres.filter((cen) => cen === centre)[0] === centre) {
          const trimname = stripSpace(centre);
          setKeyword(
            trimname.length >= 10
              ? trimname.slice(0, 10)
              : trimname.padEnd("10", nanoid(10 - trimname.length))
          );
        } else {
          showSwal("error", "Centre not Found");
          navigate("/admin/overview/centres", { replace: true });
        }
      } catch (error) {
        showSwal("error", "Centre not Found");
        navigate("/admin/overview/centres", { replace: true });
      }
      setFirst(false);
    }
  }, [centre, first, centres, navigate]);

  function handleChange(e) {
    const { name, value } = e.target;
    if (name === "crkey") {
      setCrkey(value);
      if (value !== "" && value !== keyword) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      if (crkey === keyword && keyword !== "loading...") {
        const res = await deleteCentre(centre);
        if (res === "Deleted") {
          setCentres((old) => old.filter((cen) => cen !== centre));
          setTimeout(() => {
            setStatus({
              status: "success",
              type: "success",
              message: "Deleted Successfully. Redirecting...",
            });
            setCrkey("");
            setTimeout(() => {
              navigate("/admin/overview/centres", { replace: true });
            }, 2000);
          }, 1000);
        } else if (res === "Not Found") {
          showSwal("error", "Centre not Found");
          navigate("/admin/overview/centres", { replace: true });
        } else {
          setTimeout(() => {
            setStatus({
              status: "error",
              type: "failed",
              message: "Delete Failed",
            });
            setLoading(false);
          }, 1000);
        }
      } else {
        setTimeout(() => {
          setStatus({
            status: "error",
            type: "error",
            message: "Incorrect Key",
          });
          setLoading(false);
        }, 1000);
      }
    } catch (error) {
      setStatus({ status: "error", type: "failed", message: "Delete Failed" });
      setLoading(false);
    }
  }

  useEffect(() => {
    if (status.message !== "") {
      document
        .getElementById("status-wrapper")
        .scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [status]);

  document.title = "Delete Centre";

  return (
    <div className="attendanceform">
      <div className="formwrapper">
        <div className="wrapper" style={{ color: "#002F63" }}>
          <div className="form-box login">
            <h2>Delete Centre</h2>
            <form onSubmit={handleSubmit}>
              {status.message !== "" && (
                <p className="status-wrapper" id="status-wrapper">
                  <span className={`status-message ${status.type}`}>
                    {status.message}
                  </span>
                  <LiaTimesCircle
                    className="status-close"
                    onClick={() => {
                      setStatus({ status: "", type: "", message: "" });
                    }}
                  />
                </p>
              )}
              <p style={{ fontSize: "16px", marginTop: "5px" }}>
                Type <strong>{keyword}</strong> to complete removal process
              </p>
              <div className="input-box">
                <span className="icon">
                  <FaKey />
                </span>
                <input
                  readOnly={loading}
                  type="text"
                  onChange={handleChange}
                  value={crkey}
                  autoComplete="off"
                  maxLength={10}
                  minLength={10}
                  required
                  className="input"
                  id="crkey"
                  name="crkey"
                  placeholder=" "
                />
                <label>Key</label>
              </div>
              <button
                className="btn"
                disabled={disabled || loading || keyword === "loading..."}
              >
                {loading ? <FaSpinner className="spinner" /> : "Remove"}
              </button>
              <p style={{ fontSize: "14px", marginTop: "5px" }}>
                <strong>Note:</strong> This action is final and irreversible.
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
